const topics = [
  { name: '热门电影推荐', heat: '980万热度', trend: 'up' },
  { name: '暑期追剧指南', heat: '860万热度', trend: 'up' },
  { name: '4K超清专区', heat: '750万热度', trend: 'hot' },
  { name: '国产悬疑剧', heat: '720万热度', trend: 'up' },
  { name: '韩剧热播榜', heat: '680万热度', trend: 'up' },
  { name: '动漫新番速递', heat: '650万热度', trend: 'up' },
  { name: '经典港片回顾', heat: '590万热度', trend: 'stable' },
  { name: '纪录片精选', heat: '520万热度', trend: 'stable' },
  { name: 'AI智能推荐', heat: '480万热度', trend: 'new' },
  { name: '离线下载攻略', heat: '450万热度', trend: 'up' },
];

const trendIcons: Record<string, string> = {
  up: 'ri-arrow-up-line',
  hot: 'ri-fire-line',
  stable: 'ri-subtract-line',
  new: 'ri-sparkling-line',
};

const trendColors: Record<string, string> = {
  up: 'text-accent-600',
  hot: 'text-red-500',
  stable: 'text-foreground-400',
  new: 'text-green-500',
};

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-50">
      <div className="mx-auto max-w-screen-2xl px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
            热门话题
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            全网影迷正在热议的焦点话题
          </p>
        </div>

        <div className="max-w-4xl mx-auto">
          <div className="flex flex-wrap justify-center gap-3">
            {topics.map((t) => (
              <div
                key={t.name}
                className="group inline-flex items-center gap-2 px-4 py-2.5 rounded-full bg-white border border-secondary-200 hover:border-primary-300 hover:bg-primary-50 transition-all cursor-pointer"
              >
                <span className="text-sm font-medium text-foreground-800 whitespace-nowrap">
                  #{t.name}
                </span>
                <span className="flex items-center gap-0.5 text-xs text-foreground-400 whitespace-nowrap">
                  <i className={`${trendIcons[t.trend]} ${trendColors[t.trend]} text-xs`}></i>
                  {t.heat}
                </span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}